import { useState, useCallback, ChangeEvent, useMemo } from 'react';
import { useAppDispatch } from 'redux/hooks/useAppDispatch';
import { resetSearchResults } from 'redux/modules/Discounts/discounts';
import { debounce } from 'lodash';

export const useDebounce = (
  delay: number,
): [string, (e: ChangeEvent<HTMLInputElement>) => void, () => void] => {
  const dispatch = useAppDispatch();

  const [searchValue, setSearchValue] = useState<string>('');

  const reset = useCallback(() => {
    setSearchValue('');
    dispatch(resetSearchResults());
  }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (!value) {
      reset();
      return;
    }

    setSearchValue(value);
  };

  const debouncedHandler = useMemo(
    () => debounce(handleChange, delay),
    [searchValue, delay],
  );

  return [searchValue, debouncedHandler, reset];
};
